import {useQuery} from 'react-query';

const {RECO_API_URL} = process.env;

const fetchRecommendedStyles = async (styleId, colorId) => {
  const response = await fetch(
    `${RECO_API_URL}/api/v1/related-products/${styleId}?limit=4&colorId=${colorId}`
  );
  if (!response.ok) {
    throw new Error('Failed to fetch recommended styles', {
      response,
      styleId
    });
  }
  return response.json();
};

const useRecommendedStyles = (styleId, colorId, options = {}) => {
  return useQuery({
    queryFn: () => fetchRecommendedStyles(styleId, colorId),
    queryKey: ['recommendations', styleId, colorId],
    ...options
  });
};

export default useRecommendedStyles;
